// bernie
import { SerializedData, Store } from 'bernie-core';
import { Logger, NOOP_LOGGER } from 'bernie-logger';
import { action, makeObservable, observable } from 'mobx';

// data
// tslint:disable-next-line:no-require-imports no-var-requires
// const { filteredCountries } = require('../data/filtered_countries.json');

export class CountriesStore extends Store {
  private filteredCountries: [string, any];
  public countries: Map<string, string>;
  private defaultLocale = 'en-us';

  public constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);

    // tslint:disable-next-line:no-require-imports no-var-requires
    this.filteredCountries = require('../data/filtered_countries.json');

    makeObservable(this, {
      countries: observable,
      fetchForLocale: action,
    });
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public fetchForLocale(locale: string) {
    this.countries = this.filterByLocale(locale.toLowerCase().replace('_', '-'));
  }

  // The source list is { 'locale' : { 'ISO': 'name', ... } }
  // So we go through, filtering for the locale we want, and falling back to the 'en-us' name if it's absent
  // The output is a Map<'ISO code', 'countryname'>
  public filterByLocale(locale: string): Map<string, string> {
    const sortLocale = locale.split('-')[0];

    return new Map<string, string>(
      Object.entries(this.filteredCountries[locale] ?? this.filteredCountries['en-us']).sort(
        (a: [string, string], b: [string, string]) => a[1].localeCompare(b[1], sortLocale),
      ) as Array<[string, string]>,
    );
  }
}
